export default "https://d3fbpisbzpk8wt.cloudfront.net/202512495454/receiptScanNgTilted-bundle-91afe0c2e37cc9691a23c289bd7b5ad6.png";